export default "__VITE_ASSET__CrYA5yGQ__"